import Base from "../../../base";
import OrderRepealService from "../../../../services/order/repeal";
import Detail from "../../../layout/detail/detail";

export default class OrderRepealDetail extends Base
{
    boot() {
        this.state = {
            model:{}
        }
    }

    service() {
        return OrderRepealService;
    }

    componentDidMount() {
        /*global layer */
        this.server.getDetail(this.getPropsParams('id'), data => {
            this.setModel(data);
        })
    }

    render() {
        return (
            <Detail
                model={this.state.model}
                fields={[
                    {
                        title:'工单信息',
                        fields:{
                            orderSn:'工单编号',
                            username:'联系人',
                            phone:'电话',
                            address:'地址',
                            remark:{name:'备注', block: true},
                            statusDup:'状态',
                            //visitedAt:'上门时间',
                            servedAt:'完成时间',
                            createdAt:'添加时间',
							notes:{name:'员工备注',block: true},
                        }
                    },
                    {
                        title:'商户信息',
                        fields:{
                            'client.company.name':'所属公司',
                            'client.name':'商户名称',
                            detail:{name:'详情', type :'itemComponent', component: () => {
                                    return (
                                        <button className={"layui-btn layui-btn-sm layui-btn-normal"} onClick={e => this.showClient()}>
                                            <i className="layui-icon layui-icon-list"></i>
                                            查看
                                        </button>
                                    )
                                }
                            },
                        }
                    },
                    {
                        title:'撤机人信息',
                        fields:{
                            'repealUser.realname':'负责人',
                            installBtn:{
                                name:'撤机人信息',
                                show: model => {
                                    return model.repealUid;
                                },
                                type:'itemComponent',
                                component: () => {
                                    return (
                                        <button className={"layui-btn layui-btn-sm layui-btn-normal"} onClick={e => this.showCompanyUser()}>
                                            <i className="layui-icon layui-icon-list"></i>
                                            查看
                                        </button>
                                    )
                                }
                            }
                        }
                    },
                    {
                       title:'终端信息',
                       fields:{
                           terminalCode:'终端号',
                           terminal:{
                               name:"详情",
                               type:'itemComponent',
                               show:() => {
                                  return this.state.model.terminalId;
                               },
                               component: () => {
                                   return (
                                       <button className={"layui-btn layui-btn-sm layui-btn-normal"} onClick={e => this.showTerminal()}>
                                           <i className="layui-icon layui-icon-list"></i>
                                           查看
                                       </button>
                                   )
                               }
                           }
                       }
                    },
                    {
                        title:'撤机信息',
                        show:model => {
							return model.status !== 0;
                         //   return model.status === 1;
                        },
                        fields:{
                            facadeImg:{name:'门面照', type:'slide', slide: 'slide'},
                            innerImg:{name:'内部照', type:'slide', slide: 'slide'},
                            deskImg:{name:'前台照', type:'slide', slide: 'slide'},
                            physicalImg:{name:'机身照', type:'slide', slide: 'slide'},
                            salesImg:{name:'签购单', type:'slide', slide: 'slide'},
							signImg:{name:'签名照', type:'slide', slide: 'slide'},
                            result:{name:'结果', value: model => { return this.server.result[model.result] }, block: true},
                            reason:{name:'备注原因', block: true},
							posDeviceNum:{name:'机身号', block: true}
                        }
                    }
                ]}
            />
        )
    }

    showClient() {
        this.layOpen({
            title:'查看商户 ' + this.state.model.client.name,
            content:'/admin/user/detail/'+this.state.model.uid,
            area:['900px', '96%'],
            btn:['确定'],
            yes: (index) => {
                layer.close(index);
            }
        })
    }

    showCompanyUser() {
        let repealUser = this.state.model.repealUser;
        this.layOpen({
            title:'查看撤机人' + repealUser.realname,
            content:'/admin/company/user/detail/'+ repealUser.id,
            area:['800px', '90%'],
            btn:['确定'],
            yes: index => {
                layer.close(index);
            }
        })
    }

    showTerminal() {
        this.layOpen({
            title:'详情',
            content:'/admin/user/device/detail/' +this.state.model.terminalId,
            area: ['90%', '98%'],
            yes: (index) => {
                layer.close(index);
            }
        })
    }
}
